<template>
  <start-page>
    <div class="register">
      <modal-title>Регистрация</modal-title>

      <form v-if="!isRegisterSuccess" v-on:change="validate()" v-on:submit.prevent="register()" novalidate>
        <custom-input
          inputType="text"
          placeholder="Введите имя"
          labelText="ФИО"
          v-model="data.body.name"
          required
          :errorMessage="errors['name']"
        />

        <custom-input
          inputType="email"
          placeholder="name@domen.com"
          labelText="Электронная почта"
          v-model="data.body.email"
          required
          :errorMessage="errors['email']"
        />

        <!-- Скрываем телефон, возможно потом вернем -->
        <custom-input
          id="register-phone"
          inputType="phone"
          required
          placeholder="+7 (___) ___ __ __"
          labelText="Телефон"
          v-model="data.body.phone"
          :errorMessage="errors['phone']"
        />

        <custom-checkbox id="agreement" v-model="agreement" labelText="Я согласен с условиями"/>
        <span v-b-modal.modal1 class="register-agreement">пользовательского соглашения</span>

        <vue-recaptcha
          class="recaptcha"
          @verify="isCaptchaOk = true"
          sitekey="6Ld3XdYlAAAAAGyr4vAEcFROYWVDEtRO6boCzkcs"
        />

        <main-button class="login-button" fullWidth v-if="logging" disabled>Идёт регистрация</main-button>
        <main-button :disabled="!agreement || !isCaptchaOk" class="login-button" fullWidth v-else type="submit">
          Зарегистрироваться
        </main-button>
        <b-progress v-if="logging" :value="logging" variant="success" striped/>
      </form>

      <inner-link v-if="!isRegisterSuccess" class="register-link" to="/login">Отмена</inner-link>

      <div class="register-notification" v-if="isRegisterSuccess">
        <main-text class="register-notification-text">Ваш аккаунт успешно создан!</main-text>
        <main-text class="register-notification-text">Пароль выслан на указанный при регистрации e-mail.</main-text>
        <main-button @click="finish" class="login-button" fullWidth>Вернуться в начало</main-button>
      </div>

      <!-- Modal Component -->
      <b-modal id="modal1" size="lg" hide-footer title="Пользовательское соглашение">
        <agreement/>
      </b-modal>
    </div>
  </start-page>
</template>

<style scoped>
.register {
  width: 372px;
  margin: 0 auto;
  padding: 36px;
  box-shadow: 0px 3px 8px rgba(5, 6, 36, 0.15), 0px 1px 4px rgba(5, 6, 36, 0.12);
  border-radius: 6px;
  background-color: var(--white-color);
}

.register-agreement {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-color);
  cursor: pointer;
  padding-left: 26px;
  opacity: 1;
  transition: opacity 0.15s ease-out;
}

.register-agreement:hover {
  opacity: 0.75;
}

.recaptcha {
  width: max-content;
  margin: 24px auto;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  border-right: 1px solid var(--border-color);
}

.register-link {
  margin: 24px auto 0;
}

.register-notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
}

.register-notification-text {
  margin-bottom: 32px;
  text-align: center;
}

.register-notification-text:last-of-type {
  margin-bottom: 48px;
}
</style>
<script>
import StartPage from "./StartPage.vue";
import ModalTitle from "../ui/ModalTitle.vue";
import agreement from "../../views/agreement.vue";
import Input from "../ui/Input.vue";
import Checkbox from "../ui/Checkbox.vue";
import Button from "../ui/MainButton.vue";
import InnerLink from "../ui/InnerLink.vue";
import Text from "../ui/Text.vue";
import {VueRecaptcha} from "vue-recaptcha";

export default {
  components: {
    agreement,
    VueRecaptcha,
    StartPage,
    ModalTitle,
    InnerLink,
    "custom-input": Input,
    "custom-checkbox": Checkbox,
    "main-button": Button,
    "main-text": Text,
  },
  data() {
    return {
      agreement: false,
      errors: {},
      timer: null,
      logging: false,
      requiredFields: ["email", "name", "phone"],
      data: {
        body: {
          username: "",
          email: "",
          phone: "",
          name: "",
        },
      },
      sended: false,
      error: null,
      isCaptchaOk: false,
      isRegisterSuccess: false,
    };
  },

  methods: {
    validate() {
      if (this.sended === true) {
        this.$http
          .put("auth/register?validate=true", {
            "register-form": this.data.body,
          })
          .then((response) => {
            if (response.data.errors) {
              this.errors = [];
              for (const prop in response.data.errors) {
                var key = prop.replace("register-form-", "");
                this.errors[key] = response.data.errors[prop][0];
              }
            }
          });
      }
    },
    finish() {
      this.$router.push("/login");
    },
    register() {
      this.errors = {};
      this.requiredFields.forEach((field) => {
        if (!this.data.body[field]) {
          this.errors[field] = "Обязательное поле";
        }
      });
      if (Object.keys(this.errors).length) {
        return;
      }
      this.logging = 0;
      this.timer = setInterval(() => {
        if (this.logging < 100) {
          this.logging += 10;
        }
      }, 10);
      this.$auth.register({
        data: {"register-form": this.data.body}, // Axios
        success: function () {
          clearInterval(this.timer);
          this.logging = false;
          this.isRegisterSuccess = true;

          if (process.env.NODE_ENV === "production") {

            // dashamail track register event
            window.dashamail("async", {
              operation: "UserRegistration",
              data: {
                customer: {
                  name: this.data.body.name,
                  email: this.data.body.email,
                  mobilePhone: this.data.body.phone
                }
              }
            });

            // roistat track register event
            window.roistat.event.send("UserRegistration", {
              client: {
                name: this.data.body.name,
                phone: this.data.body.phone,
                email: this.data.body.email
              }
            });
          }
          return false;
        },
        error: function (error) {
          clearInterval(this.timer);
          this.logging = false;
          if (error.response.data.errors) {
            this.sended = true;
            this.errors = [];
            for (var prop in error.response.data.errors) {
              var key = prop.replace("register-form-", "");
              this.errors[key] = error.response.data.errors[prop][0];
            }
          }
        },
        redirect: null,
      });
    },
  },
};
</script>
